export default "__VITE_PUBLIC_ASSET__dbecacac__"